import React from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="px-4 pt-6 pb-8 md:pt-10 md:pb-12" data-id="element-35">
      <div className="text-center" data-id="element-36">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3" data-id="element-37">
          5 Shocking Reasons Men Over 40 Are Turning to Alpha Gummies
        </h1>
        <h2 className="text-xl md:text-2xl text-gray-700 italic mb-6" data-id="element-38">
          (#5 Made My Wife Freak Out)
        </h2>
        <div className="mb-6" data-id="element-39">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/joFqFzVkGJDmMhfgncPLo2/1_04765e1a-b2c8-48e2-827a-199d81bcf502.png" alt="PureNutra Alpha Gummies product" className="mx-auto rounded-lg shadow-md max-w-full md:max-w-lg" data-id="element-40" />
        </div>
        <div className="mb-4" data-id="element-41">
          <CTAButton data-id="element-42" />
        </div>
        <div className="flex items-center justify-center text-sm text-gray-500 gap-1" data-id="element-43">
          <span className="inline-block px-2 py-1 bg-green-100 text-green-800 rounded-full font-medium" data-id="element-44">
            Limited Time Offer
          </span>
          <span data-id="element-45">•</span>
          
          <span data-id="element-46">Free Shipping</span>
          <span data-id="element-47">•</span>
          <span data-id="element-48">60-Day Guarantee</span>
        </div>
      </div>
    </section>;
}